import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SuperAdminClearDataModal = ({ isOpen, onClose, onConfirm, loading, stats }) => {
  const [confirmText, setConfirmText] = useState('');
  const CONFIRM_PHRASE = 'SUPPRIMER TOUT';

  if (!isOpen) return null;

  const handleConfirm = () => {
    if (confirmText === CONFIRM_PHRASE) {
      onConfirm();
    }
  };

  const isConfirmDisabled = confirmText !== CONFIRM_PHRASE || loading;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-card rounded-2xl shadow-2xl border border-white/8 max-w-lg w-full p-6 animate-fadeIn">
        {/* Warning Icon */}
        <div className="flex justify-center mb-4">
          <div className="w-20 h-20 bg-error-bg rounded-full flex items-center justify-center">
            <Icon name="AlertTriangle" size={40} className="text-error" />
          </div>
        </div>

        {/* Title */}
        <h2 className="text-2xl font-bold text-primary text-center mb-2">
          Supprimer TOUTES les données
        </h2>
        <p className="text-center text-muted mb-4">
          Super Admin - Suppression complète
        </p>

        {/* Critical Warning Message */}
        <div className="bg-error-bg border-2 border-error/30 rounded-xl p-4 mb-4">
          <p className="text-sm text-error font-bold mb-3 flex items-center gap-2">
            <Icon name="AlertTriangle" size={18} />
            DANGER : Cette action est IRRÉVERSIBLE !
          </p>
          <div className="space-y-2 text-sm text-secondary">
            <p>• Tous les adressages seront supprimés</p>
            <p>• Tous les praticiens sans compte utilisateur seront supprimés</p>
            <p>• Les données ne pourront PAS être récupérées</p>
          </div>
        </div>

        {/* Statistics Preview */}
        {stats && (
          <div className="bg-card-elevated border border-white/8 rounded-xl p-4 mb-4">
            <p className="text-sm font-medium text-secondary mb-2">Données qui seront supprimées :</p>
            <div className="grid grid-cols-2 gap-3 text-sm">
              <div className="flex items-center gap-2">
                <Icon name="FileText" size={16} className="text-muted" />
                <span className="text-secondary">
                  <strong className="text-primary">{stats?.referralCount || 0}</strong> adressages
                </span>
              </div>
              <div className="flex items-center gap-2">
                <Icon name="Users" size={16} className="text-muted" />
                <span className="text-secondary">
                  <strong className="text-primary">{stats?.practitionerCount || 0}</strong> praticiens
                </span>
              </div>
            </div>
          </div>
        )}

        {/* Confirmation Input */}
        <div className="mb-6">
          <label className="block text-sm font-medium text-secondary mb-2">
            Pour confirmer, tapez <span className="font-bold text-error">{CONFIRM_PHRASE}</span>
          </label>
          <input
            type="text"
            value={confirmText}
            onChange={(e) => setConfirmText(e?.target?.value)}
            placeholder="Tapez SUPPRIMER TOUT"
            className="w-full px-4 py-3 bg-card-elevated border-2 border-white/8 rounded-xl focus:ring-2 focus:ring-error focus:border-transparent text-center font-medium text-primary placeholder-muted transition-all"
            disabled={loading}
          />
        </div>

        {/* Actions */}
        <div className="flex gap-3">
          <Button
            onClick={onClose}
            disabled={loading}
            className="flex-1 px-4 py-3 bg-card-elevated hover:bg-card-hover text-secondary rounded-xl font-medium transition-colors disabled:opacity-50"
          >
            Annuler
          </Button>
          <Button
            onClick={handleConfirm}
            disabled={isConfirmDisabled}
            className="flex-1 px-4 py-3 bg-error hover:bg-error/90 text-white rounded-xl font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2 shadow-lg"
          >
            {loading ? (
              <>
                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                <span>Suppression...</span>
              </>
            ) : (
              <>
                <Icon name="Trash2" size={20} />
                <span>Supprimer TOUT</span>
              </>
            )}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SuperAdminClearDataModal;